<template>
  <v-row class="ma-0 pa-0">
    <v-col>
      <template v-for="(feature, index) in proFeatures" :key="index">
        <div v-if="index % 2 === 0" class="my-3 v-center">
          <v-icon size="20px" :color="getColor" :icon="getIcon" />
          <span class="ml-2 bold-text">{{ feature }}</span>
        </div>
      </template>
    </v-col>
    <v-col>
      <template v-for="(feature, index) in proFeatures" :key="index">
        <div v-if="index % 2 !== 0" class="my-3 v-center">
          <v-icon size="20px" :color="getColor" :icon="getIcon" />
          <span class="ml-2 bold-text">{{ feature }}</span>
        </div>
      </template>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { colors } from '@/styles/colors';

export default defineComponent({
  name: 'ProFeatures',
  props: {
    green: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      proFeatures: [
        this.$t('upselling.proFeatures.customPackages'),
        this.$t('upselling.proFeatures.smartUpdate'),
        this.$t('upselling.proFeatures.certificateManagement'),
        this.$t('upselling.proFeatures.templateManagement'),
        this.$t('upselling.proFeatures.customFields')
      ]
    };
  },
  computed: {
    getIcon(): string {
      return this.green ? 'mdi-check' : 'mdi-cancel';
    },
    getColor(): string {
      return this.green ? colors.green : colors.red;
    }
  }
});
</script>
